export default __webpack_public_path__ + "static/media/marauders-map-v3-05-04.b7448b4e.jpg";